import { isTerminateValue } from '@rehaje/shared'

import { DEFINED, TERMINATE } from './flags'

import type { Reactive } from './types'

export function define<T = any>(value: T): void
export function define(value: Reactive) {
  if (isTerminateValue(value) || value.__rr_flags & TERMINATE) return
  value.__rr_flags |= DEFINED
}
